module.exports = __webpack_public_path__ + "static/media/Delivered.e3a07df8.png";